// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import {
	RequestConsultaSituacaoAtual,
	ConsultaSituacaoAtual,
	Types,
} from './types';

export function consultaSituacaoAtualRequest(
	token: string,
	payload: RequestConsultaSituacaoAtual,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_SITUACAO_ATUAL_REQUEST,
		token,
		payload,
	};
}

export function consultaSituacaoAtualSuccess(
	payload: ConsultaSituacaoAtual,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_SITUACAO_ATUAL_SUCCESS,
		payload,
	};
}

export function consultaSituacaoAtualFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_SITUACAO_ATUAL_FAILURE,
		payload: null,
	};
}

export function consultaSituacaoAtualClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_SITUACAO_ATUAL_CLEAR,
		payload: null,
	};
}

export function atendimentoEncerrado(payload: string): ReducerActionRotaSP {
	return {
		type: Types.ATENDIMENTO_ENCERRADO,
		payload,
	};
}

export function limpaMensagemRetorno(): ReducerActionRotaSP {
	return {
		type: Types.LIMPA_MENSAGEM_RETORNO,
		payload: null,
	};
}

export function limpaPainelDeControle(): ReducerActionRotaSP {
	return {
		type: Types.LIMPA_STATE,
		payload: null,
	};
}
